import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { ROUTES } from '../routes'

interface PublicOnlyRouteProps {
  children: React.ReactNode
}

/**
 * PublicOnlyRoute Guard
 *
 * Redirects authenticated users away from public-only pages (like login/register).
 * If user is already authenticated, redirect them to the main app.
 */
export const PublicOnlyRoute: React.FC<PublicOnlyRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuthStore()

  // If user is authenticated, redirect to social-media dashboard
  if (isAuthenticated) {
    return <Navigate to={ROUTES.SOCIAL_MEDIA} replace />
  }

  // User is not authenticated, show the public page
  return <>{children}</>
}
